import { Component, input } from '@angular/core';

/**
 * Guscio di una pagina: intestazione con titolo e azioni, corpo, ed
 * eventuale barra in fondo che resta appiccicata.
 *
 * Serve a togliere alle schermate il compito di inventarsi il layout: oggi
 * ognuna mette i suoi `container-fluid`, `row` e `py-5`, con il risultato che
 * titoli e margini non sono allineati fra una pagina e l'altra.
 *
 * Uso:
 *   <app-page titolo="Articoli" sottotitolo="1.204 in archivio">
 *     <button azioni mat-flat-button>Nuovo articolo</button>
 *     ...contenuto...
 *     <div piede>...barra azioni...</div>
 *   </app-page>
 */
@Component({
  selector: 'app-page',
  standalone: true,
  templateUrl: './page.component.html',
})
export class PageComponent {
  readonly titolo = input<string>('');
  readonly sottotitolo = input<string>('');
}
